<template>
  <section id="services" class="py-24 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center max-w-3xl mx-auto mb-16">
        <h2 class="text-amber-500 font-bold uppercase tracking-wider text-sm mb-2">Our Expertise</h2>
        <h3 class="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6">Build better outcomes by working better together</h3>
        <p class="text-lg text-slate-600">
          We provide comprehensive construction solutions tailored to the unique demands of every project from initial planning to final handover.
        </p>
      </div>

      <div v-if="loading" class="text-center py-12">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500"></div>
        <p class="mt-4 text-slate-500 font-medium">Loading services...</p>
      </div>
      
      <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div v-for="service in services" :key="service.id" 
             class="group relative overflow-hidden rounded-2xl bg-slate-50 border border-slate-100 hover:shadow-2xl transition-all duration-500 h-full min-h-[320px]">
          
          <!-- Background Image if exists -->
          <div v-if="service.image_path" 
               class="absolute inset-0 z-0">
            <img :src="getImageUrl(service.image_path)" :alt="service.title" class="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700 opacity-20 group-hover:opacity-100">
            <div class="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-transparent opacity-0 group-hover:opacity-90 transition-opacity duration-500"></div>
          </div>

          <div class="relative z-10 p-8 flex flex-col h-full">
            <div class="w-14 h-14 bg-white rounded-lg shadow-sm flex items-center justify-center mb-6 group-hover:bg-amber-500 transition-colors duration-300" 
                 v-html="service.icon_svg"
                 v-if="service.icon_svg">
            </div>
            
            <h4 class="text-xl font-bold text-slate-900 group-hover:text-white mb-3 transition-colors duration-300">{{ service.title }}</h4>
            <p class="text-slate-600 group-hover:text-slate-200 leading-relaxed transition-colors duration-300 flex-grow">
              {{ service.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import serviceService from '@/services/serviceService';

export default {
  name: 'ServicesSection',
  data() {
    return {
      services: [],
      loading: true
    }
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL.replace('/api', '') : 'https://em-admin.test';
    }
  },
  async created() {
    try {
      const response = await serviceService.getServices();
      this.services = response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    getImageUrl(path) {
      if (!path) return '';
      if (path.startsWith('http')) return path;
      return `${this.apiUrl}/${path}`;
    }
  }
}
</script>
